import createModelStore from "../../utils/createModelStore";
import Schedule from "../../services/Schedule";

const schedules = createModelStore<Schedule.Model, "schedules">("schedules");

export default schedules;
